import React, { useState } from 'react';
import { useAppContext } from '../context/AppContext';
import LoginPage from './LoginPage';
import RegisterPage from './RegisterPage';

const AuthPage = () => {
    const { theme } = useAppContext();
    const [isRegistering, setIsRegistering] = useState(false);

    return (
        <div className={`flex items-center justify-center min-h-screen p-4 ${theme === 'dark' ? 'bg-gray-950' : 'bg-gray-50'}`}>
            {isRegistering ? (
                <RegisterPage onSwitchToLogin={() => setIsRegistering(false)} />
            ) : (
                <LoginPage onSwitchToRegister={() => setIsRegistering(true)} />
            )}
        </div>
    );
};

export default AuthPage;